export const TXM_BUYERS_PATH = '/buyers';
export const TXM_CUSTOMIZE_HOME_PATH = '/customize';
export const TXM_LEASES_PATH = '/leases';
export const TXM_LISTINGS_PATH = '/listings';
export const TXM_OFFERS_PATH = '/offers';
export const TXM_REFERRALS_PATH = '/referrals';
export const TXM_REPORTS_PATH = '/reports';
export const TXM_TEMPLATES_PATH = '/templates';

export const paths = {
  toListing: (id: string) => `${TXM_LISTINGS_PATH}/${id}`,
  toListingOffers: (id: string) => `${TXM_LISTINGS_PATH}/${id}/offers`,
  toListingOffer: (listingId: string, offerId: string, edit?: boolean) =>
    `${TXM_LISTINGS_PATH}/${listingId}/offers/${offerId}${edit ? '?edit=true' : ''}`,
  toListingNewOffer: (id: string) => `${TXM_LISTINGS_PATH}/${id}/offers/new`,
};

export type NavBarPath = {
  disabled?: boolean;
  label: string;
  path: string;
  section?: string;
};

export const LINK_LABELS: Record<string, string> = {
  COVER_SHEET: 'Cover Sheet',
  GENERATE_OFFER: 'GENERATE OFFER',
  OFFER_DOCUMENTS: 'OFFER DOCUMENTS',
};
